import styled from 'styled-components';

export const JoditEditorWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .jodit-react-container {
    width: 100%;
    .jodit-container {
      border: 1px solid ${({ theme }) => theme.colors.grayVariations.murky};
    }
  }
`;
